import Head from 'next/head'

export const MetaTags = ( { metaTags } ) => (
  <Head>
    { metaTags.map( tag => {
      if ( tag.name === 'title' ) {
        return <title key="title">{ tag.value }</title>
      }

      if ( tag.name === 'description' ) {
        return <meta key="description" name="description" content={ tag.value } />
      }

      return <meta key={ tag.name } property={ tag.name } content={ tag.value } />
    } ) }
  </Head>
)

export const withMetaTags = PageComponent => {
  const WithMetaTags = pageProps => (
    <>
      { pageProps.entry?.metaTags && <MetaTags metaTags={ pageProps.entry.metaTags } /> }
      { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
      <PageComponent { ...pageProps } />
    </>
  )

  return WithMetaTags
}
